import { ShellB } from "@/components/konsept-b/shell";
import { HomeB } from "@/components/konsept-b/home";

export function KonseptB() {
  return (
    <ShellB>
      <HomeB />
    </ShellB>
  );
}
